import { ERRORS, LOADING, SET_DATA } from '@/bus/texts/types'

const initialState = {
  loading: false,
  loaded: false,
  failed: false,
  data: {}
}

export function textsReducer(state = initialState, action: any) {
  switch (action.type) {
    case ERRORS:
    case SET_DATA:
    case LOADING: {
      return {
        ...state,
        ...action.payload
      }
    }
    default:
      return state
  }
}
